// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

class AnnouncementBar extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host([loaded]) {
        max-height: var(--Announcement_Height);
      }
      @media (prefers-reduced-motion: no-preference) {
        :host([loaded]) {
          transition: max-height 0.3s ease, background-color 0.3s ease;
        }
      }
    `
  }

  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.announcementHeight = this.els.body.element.offsetHeight

    document.documentElement.style.setProperty(
      '--Announcement_Height',
      `${this.announcementHeight}px`,
    )

    this.setAttribute('loaded', '')

    if (this.els.slide.elements.length < 2) return

    this.interval = 0

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      loop: true,
      renderMode: 'custom',
      slideChanged: this.onSlideChanged,
      created: () => {
        this.autoplay(true)
      },
      dragStarted: () => {
        this.autoplay(false)
      },
      dragEnded: () => {
        this.autoplay(true)
      },
    })
  }

  autoplay (run) {
    clearInterval(this.interval)

    this.interval = setInterval(() => {
      if (run && this.carousel) {
        this.carousel.next()
      }
    }, 3000)
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })

    this.style.setProperty(
      '--Background_Color',
      this.els.slide.elements[currentSlide].dataset.background,
    )
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    const offsetAmount =
      this.lastKnownY < this.announcementHeight
        ? this.lastKnownY
        : this.announcementHeight

    document.body.style.setProperty(
      '--AnnouncementBarScrollOffset',
      `-${offsetAmount}px`,
    )
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
